export default {
  data() {
    return {
      roleForm: {
        basic: {},
        char: {},
        user: {},
        stats: {}
      },
      roleUser: {
        uname: "",
        uemail: "",
        udid: ""
      }
    };
  }
};
